import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { apiAction } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';

const GeneralSettings = () => {
  const dispatch = useDispatch();
  const { generalSettings, activeGeneralSetting } = useSelector((state) => state.general);
  console.log({ generalSettings, activeGeneralSetting });

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'generalSettings',
        route: 'generalSettings/getGeneralSettings',
      })
    );
    dispatch(
      apiAction({
        reduxField: 'activeGeneralSetting',
        route: 'generalSettings/getActiveGeneralSetting',
      })
    );
  }, [dispatch]);

  let activeGeneralSettingId = activeGeneralSetting?._id ? activeGeneralSetting._id : '';

  const generalSettingColumns = [
    {
      field: 'id',
      headerName: 'id',
      width: 350,
      renderCell: (params) => {
        return (
          <Link to={`/generalSetting/${params.row.id}`}>
            {params.value} {params.row.id === activeGeneralSettingId ? '(Active)' : ''}
          </Link>
        );
      },
    },
    {
      field: 'name',
      headerName: 'name',
      width: 400,
    },
    {
      field: 'spendDisPercentage',
      headerName: 'spendDisPercentage',
      width: 200,
    },
    {
      field: 'ruleFrequency',
      headerName: 'ruleFrequency',
      width: 200,
    },
  ];

  return (
    <div className='container mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center'>
        <div className='col-lg-12 d-flex justify-content-center border-bottom' data-aos='fade-up' data-aos-delay='200'>
          <h1>General Settings</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        <div data-aos='fade-up' data-aos-delay='200'>
          {Array.isArray(generalSettings) ? (
            <div className='border p-2' data-aos='fade-up' data-aos-delay='200'>
              <Box style={{ height: 600, width: '100%' }}>
                <DataGrid
                  rows={generalSettings.map((setting) => ({ ...setting, id: setting._id }))} // id is required for DataGrid
                  columns={generalSettingColumns}
                  pageSize={5}
                  rowsPerPageOptions={[5]}
                  //   checkboxSelection
                  disableSelectionOnClick
                />
              </Box>
            </div>
          ) : (
            <Spinner />
          )}
        </div>
      </div>
    </div>
  );
};

export default GeneralSettings;
